import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { BucketStatusKpiCfg, BucketStatusKpiCfgService } from "./bucketsStatusKpiCfg.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class BucketStatus {
    public name: string
    public remaining: number;
}

export class BucketsStatusServiceData {
    public remaining: number;
    public buckets: BucketStatus[];
    public updateTimestamp: Date;
}

@Injectable()
export class BucketsStatusService extends KpiService<BucketsStatusServiceData> {
    public getClassName() { return "BucketsStatusService"; }

    constructor(
        private serviceCfg: BucketStatusKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<BucketsStatusServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: BucketsStatusServiceData = null;
            try {
                let cfg: BucketStatusKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.bucketStatus.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.get<BucketsStatusServiceData>(url).toPromise();

                if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
                else return result;
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
